import { reactive } from 'vue'

export const loginManager = reactive({
  visible: false,
  resolve: null,
  reject: null,
  
  show() {
    this.visible = true
    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  },
  
  success(token) {
    localStorage.setItem('loginUserToken', token)
    this.visible = false
    if (this.resolve) {
      this.resolve({ token })
    }
  },
  
  cancel() {
    this.visible = false
    if (this.reject) {
      this.reject(new Error('用户取消登录'))
    }
  }
})